import styled from 'styled-components';

export const LineInputTwo = styled.div`
  display: flex;
  align-items: flex-end;

  > div {
    &:first-child {
      max-width: 130px;
    }

    & + div {
      flex: 1;
      margin-left: 30px;
    }
  }
`;

export const LineInputThree = styled.div`
  display: flex;
  align-items: flex-end;

  > div {
    &:first-child {
      max-width: 210px;
    }

    & + div {
      flex: 1;
      margin-left: 30px;
    }
  }
`;
